var DateTimePicker = (function() {
    let _this, INSTANCES;

    INSTANCES = {};

    function init() {
        AirDatepicker.defaults.locale = ScoreTrekBattle.Translator.get('air-datepicker');
    }

    function show(instance) {
        instance.$el.style.color = 'transparent';
        instance.$el.style.caretColor = 'transparent';
    }

    function hide(instance) {
        instance.$el.style.color = '';
        instance.$el.style.caretColor = '';

        instance.hide();
    }

    function activate(element, options, isTime) {
        let onShow, onHide, instanceId, instance, initialValue;

        instanceId = element.dataset.airDatepicker || DataHandler.id();

        if (INSTANCES.hasOwnProperty(instanceId)) {
            INSTANCES[instanceId].destroy();
        }

        onShow = options.onShow || function() {};
        onHide = options.onHide || function() {};

        options.onShow = function(isFinished) {
            if (isFinished) {
                return;
            }

            selectCurrentValue(instance, isTime);
            
            initialValue = instance.$el.value;

            show(instance);

            onShow.apply(this, arguments);
        };

        options.onHide = function(isFinished) {
            if (!isFinished) {
                return;
            }

            AnimationHandler.removeFocus();

            onHide.apply(this, arguments);
        };

        options.buttons = [
            {
                content: __i18n('button/apply'),
                className: 'button button-secondary',
                onClick: () => {
                    if (instance.$el.dataset.type === 'date') {
                        instance.$el.value = DateTime.formatDate(instance.$el.value);
                    }

                    hide(instance);
                }
            },
            {
                content: __i18n('button/cancel'),
                className: 'button button-tertiary button-border',
                onClick: () => {
                    instance.$el.value = initialValue;
                    hide(instance);
                }
            }
        ];


        instance = new AirDatepicker(element, options);
        INSTANCES[instanceId] = instance;
        element.dataset.airDatepicker = instanceId;

        return INSTANCES[instanceId];
    }

    function selectCurrentValue(instance, isTime) {
        let value, date, parts;

        value = String(instance.$el.value).trim();

        if (!value) {
            value = isTime
                ? DateTime.getCurrentTimeString(false, true)
                : DateTime.getCurrentDateString(false, true)
            ;
        }

        if (isTime) {
            parts = value.split(':');

            date = new Date();
            date.setHours(
                parseInt(parts[0], 10) || 0,
                parseInt(parts[1], 10) || 0,
                parseInt(parts[2], 10) || 0,
                0
            );
        } else {
            date = new Date(value);
        }

        if (isNaN(date.getTime())) {
            return;
        }

        instance.selectDate(date, {silent: true, updateTime: true});
    }


    function getDefaultOptions() {
        return {
            autoClose: false,
            isMobile: true,
            fixedHeight: true,
            prevHtml: '<i class="fa-solid fa-angle-left"></i>',
            nextHtml: '<i class="fa-solid fa-angle-right"></i>'
        };
    }

    window.addEventListener('load', function() {
        init();
    });


    _this = {
        activateDate: function(element, options) {
            options = $.extend(getDefaultOptions(), {
                dateFormat: 'yyyy-MM-dd',
            }, options);

            return activate(element, options, false);
        },

        activateTime: function(element, options) {
            options = $.extend(getDefaultOptions(), {
                timepicker: true,
                onlyTimepicker: true,
                timeFormat: 'HH:mm'
            }, options);

            return activate(element, options, true);
        }
    };

    document.addEventListener('click', function(event) {
        if (!event.target.classList.contains('air-datepicker-overlay')) {
            return;
        }

        event.stopPropagation();
    }, {capture: true});


    return _this;
})();